<template>
    <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="onHide" @show="onShow">
        <template #reference>
            <div class="th-filter-down">
                <i :class="['el-icon-arrow-down', iconActive ? 'el-icon-arrow-down-active' : '']"></i>
            </div>
        </template>

        <template>
            <div class="multiselect-container">
                <el-input class="input-filter" v-model="filterText" :placeholder="$t('btn_search')"
                    prefix-icon="el-icon-search" clearable></el-input>
                <div class="selectall-row">
                    <span class="selectall-item" @click="selectAll">{{ $t('select_all') }}</span>
                    <span class="selectall-item" @click="unSelectAll">{{ $t('unselect_all') }}</span>
                </div>
                <div class="multiselect-tree-wrap">
                    <el-tree ref="tree" :data="realOptions" show-checkbox node-key="topicId"
                        :filter-node-method="filterNode" :props="defaultProps">
                    </el-tree>
                </div>
            </div>
        </template>
    </el-popover>
</template>

<script>
export default {
    name: 'TopicMultiSelectPopver',
    props: {
        options: {
            type: Array,
            default: () => []
        },
        hidePopperSearch: Function,
        initPopperData: Function,//针对初次打开弹窗，动态获取数据的情况
        inputFilterKey: {
            type: Array,
            default: ['value']
        },
        value: [],
        valueKey: {
            type: String,
            default: 'value'
        },
        labelKey: {
            type: String,
            default: 'label'
        },
        dayOverDue: {
            type: Array,
            default: () => ['', '']
        },
        daysUntilDue: {
            type: Array,
            default: () => ['', '']
        },
        iconColor: {
            type: String,
            default: '#3879eb'
        },
        iconSize: {
            type: String | Number,
            default: '13'
        }
    },
    data() {
        return {
            topicInputFilter: '',
            filterText: '',
            valueHere: [],
            dayOverDueHere: ['', ''],
            daysUntilDueHere: ['', ''],
            defaultProps: {
                children: 'childTopic',
                label: 'topicName'
            },
            realOptions: [],
            current: [],
            flagList: [],
        }
    },
    computed: {
        optionsHere() {
            return this.options.filter(v => {
                return this.inputFilterKey.some(vv => {
                    return v[vv] && `${v[vv]}`.toLowerCase().indexOf(this.topicInputFilter.toLowerCase()) > -1
                })
            }).map((v, k) => {
                if (['空', 'Empty'].includes(v[this.labelKey]) || v[this.labelKey].indexOf('空') > -1) {
                    v.sort = -99999
                } else {
                    v.sort = k
                }
                return v
            }).sort((a, b) => a.sort - b.sort)
        },
        iconActive() {
            return (this.valueHere && this.valueHere.length > 0) || this.dayOverDueHere.some(v => v !== '') || this.daysUntilDueHere.some(v => v !== '')
        }
    },
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.topicName.indexOf(value) !== -1;
        },
        onShow() {
            this.flagList = []
            if (this.options.length < 1) {
                this.initPopperData && this.initPopperData()
            }
            this.$refs.tree.setCheckedKeys(this.value)
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        },
        onHide() {
            //  
            // if (this.dayOverDueHere[0] > 0 && this.dayOverDueHere[1] > 0 && (this.dayOverDueHere[0] - 0) > (this.dayOverDueHere[1] - 0)) {
            //     this.$message.error(this.$t('few_days_later_input_disallow'))
            //     this.dayOverDueHere[0] = ''
            //     this.dayOverDueHere[1] = ''
            //     return
            // }

            // if (this.daysUntilDueHere[0] > 0 && this.daysUntilDueHere[1] > 0 && (this.daysUntilDueHere[0] - 0) > (this.daysUntilDueHere[1] - 0)) {
            //     this.$message.error(this.$t('few_days_later_input_disallow'))
            //     this.daysUntilDueHere[0] = ''
            //     this.daysUntilDueHere[1] = ''
            //     return
            // }
            if (this.flagList.length) {
                this.valueHere = this.flagList
            } else {
                this.valueHere = this.$refs.tree.getCheckedKeys();
            }

            this.$nextTick(() => {
                this.hidePopperSearch && this.hidePopperSearch(false, this.current)
            })
        },
        selectAll() {
            this.valueHere = []
            // 需要递归传递多层
            const _digui = (arr) => {
                arr.forEach(v => {
                    this.valueHere.push(v.topicId)
                    if (v.childTopic && v.childTopic.length) {
                        _digui(v.childTopic)
                    }
                });
            }



            // _digui(this.optionsHere)

            // this.valueHere = this.optionsHere.map(v => v[this.valueKey])




            this.current = this.getCurrentData()

            this.valueHere = this.current.map(v => v.id)
            this.flagList = this.valueHere

            this.$refs.tree.setCheckedKeys(this.valueHere)
        },
        unSelectAll() {
            this.valueHere = []

            this.current = this.getCurrentData()

            if (this.current.length) {
                const allArr = []
                // 需要递归传递多层
                const _digui = (arr) => {
                    arr.forEach(v => {
                        allArr.push(v.topicId)
                        if (v.childTopic && v.childTopic.length) {
                            _digui(v.childTopic)
                        }
                    });
                }
                _digui(this.optionsHere)


                if (allArr.length === this.current.length) {
                    this.valueHere = []
                } else {
                    // 差集
                    this.valueHere = allArr.filter(v => !this.current.map(v => v.id).includes(v))
                }
            }

            this.flagList = this.valueHere

            this.$refs.tree.setCheckedKeys([])

        },
        // 获取过滤后的数据的操作代码
        getCurrentData() {
            const traverseNode = function (node) {
                if (Object.prototype.toString.call(node) === '[object Array]') {
                    return node.map(t => traverseNode(t))
                }
                const data = { id: node.data.topicId, label: node.data.topicName, visible: node.visible, children: [] }
                const childNodes = node.childNodes;
                childNodes.forEach((child) => {
                    const item = traverseNode(child)
                    if (item.visible) {
                        data.visible = true
                    }
                    data.children.push(item)
                });
                return data
            };

            const _newFilterArr = []
            const traverseVisible = function (arr) {
                arr.forEach(v => {
                    if (v.visible) {
                        _newFilterArr.push({
                            id: v.id,
                            label: v.label,
                        })
                    }
                    

                    if (v.children && v.children.length) {
                        traverseVisible(v.children)
                    }
                })
            }
            const data = traverseNode(this.$refs.tree.store.root.childNodes)
            traverseVisible(data)

            return _newFilterArr;
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
        value(v) {
            if (JSON.stringify(this.valueHere) === JSON.stringify(v)) return;
            this.valueHere = v

            this.$refs.tree.setCheckedKeys(v)
        },
        valueHere(v, ov) {
            this.$emit('update:value', v)
            if (this.optionsHere.some(v => v.showDayOverDue) && ov.includes('5') && !v.includes('5')) {
                this.dayOverDueHere[0] = ''
                this.dayOverDueHere[1] = ''
            }
            if (this.optionsHere.some(v => v.showDaysUntilDue) && ov.includes('6') && !v.includes('6')) {
                this.daysUntilDueHere[0] = ''
                this.daysUntilDueHere[1] = ''
            }
        },
        dayOverDueHere: {
            deep: true,
            handler(v) {
                this.$emit('update:dayOverDue', v)
            }
        },
        dayOverDue: {
            deep: true,
            handler(v) {
                this.dayOverDueHere = v
            }
        },
        daysUntilDue: {
            deep: true,
            handler(v) {
                this.daysUntilDueHere = v
            }
        },
        daysUntilDueHere: {
            deep: true,
            handler(v) {
                this.$emit('update:daysUntilDue', v)
            }
        },
        options: {
            handler(v) {
                this.realOptions = v;
            }
        }
    }
}
</script>

<style scoped>
.multiselect-container {
    display: flex;
    flex-direction: column;
    max-width: 100vw;
    max-height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.multiselect-container::-webkit-scrollbar {
    width: 0 !important
}

.multiselect-container {
    -ms-overflow-style: none;
}

.multiselect-container {
    overflow: -moz-scrollbars-none;
}

/* .th-filter-down {
    display: flex;
    flex-direction: row;
    align-items: center;
} */

.multiselect-container .selectall-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin: 10px 0;
}

.multiselect-container .selectall-row .selectall-item {
    color: #409eff;
    margin-left: 10px;
    cursor: pointer;
    font-size: 13px;
}

.multiselect-container .group-check {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}

.multiselect-container .group-check .group-check-checkbox {
    width: 100%;
    margin-bottom: 12px;
}

.multiselect-container .group-check .group-check-checkbox .checkbox-text {
    margin-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 20px;
}

.multiselect-container .group-check .group-check-checkbox .checkbox-text .input-row {
    margin-left: 20px;
    margin-top: 5px;
}

.multiselect-container .group-check .group-check-checkbox .checkbox-text .input-row .ri {
    margin: 0 10px;
}

.multiselect-container .group-check .group-check-checkbox .checkbox-text .input-row .input-row-input {
    width: 100px;
}

.multiselect-container .group-check .group-check-checkbox .text {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.multiselect-tree-wrap {
    width: 300px;
}

.multiselect-tree-wrap ::v-deep .el-tree>.el-tree-node {
    display: block;
}
</style>
